import { C_TIMELINE_MIN_DATE, C_TIMELINE_MAX_DATE, C_FIRST_DAY_HUMAN_SCORES_DATE } from '../../constants';
import { Moment } from 'moment';
//todo: refactor these objects and this entire file
const offsets: { [dateStr: string]: number } = {};
const offsetsContingent: { [dateStr: string]: number } = {};
const offsetsMoment: { [dateStr: string]: Moment } = {};
const offsetsMonthly: { [dateStr: string]: number } = {};
const offsetsMomentMonthly: { [dateStr: string]: Moment } = {};
let index = 0;
for (
    const d = C_TIMELINE_MIN_DATE.clone();
    d.isSameOrBefore(C_TIMELINE_MAX_DATE, 'days');
    d.add(1, 'days'), index++
) {
    offsets[d.format('YYYY-MM-DD')] = index;
    offsetsMoment[d.format('YYYY-MM-DD')] = d.clone();
}
index = 0;
for (
    const d = C_FIRST_DAY_HUMAN_SCORES_DATE.clone();
    d.isSameOrBefore(C_TIMELINE_MAX_DATE, 'days');
    d.add(1, 'days'), index++
) {
    offsetsContingent[d.format('YYYY-MM-DD')] = index;
}
index = 0;
for (
    const d = C_TIMELINE_MIN_DATE.clone().endOf('month').startOf('day');
    d.isSameOrBefore(C_TIMELINE_MAX_DATE, 'days');
    d.add(1, 'months').endOf('month').startOf('day'), index++
) {
    offsetsMonthly[d.format('YYYY-MM-DD')] = index;
    offsetsMomentMonthly[d.format('YYYY-MM-DD')] = d.clone();
}

const keysArray = Object.keys(offsets);
const keysMonthlyArray= Object.keys(offsetsMonthly);

function proxyGetOffsetMonthly(target: number[], key: string) {
    return target[offsets[key]];
}  
function proxyGetOffset(target: number[], key: string) {
    return target[offsets[key]];
}
function proxyGetOffsetContingent(target: number[], key: string){
    return target[offsetsContingent[key]];
}

function proxyHas(target: number[], key: string): boolean {
    return key in offsets;
}

function keys() {
    return keysArray;
}
function keysMonthly() {
    return keysMonthlyArray;
}

function momentFor(key: string) {
    return offsetsMoment[key];
}

function iterator(
    scores: number[],
    cb: (dateStr: string, moment: Moment, score: number, index?: number) => void
) {
    keysArray.forEach((k, i) => {
        cb(k, offsetsMoment[k], scores[i], i);
    });
}
function iteratorMonthly(
    scores: number[],
    cb: (dateStr: string, moment: Moment, score: number, index?: number) => void
) {
    keysMonthlyArray.forEach((k, i) => {
        cb(k, offsetsMomentMonthly[k], scores[offsets[k]], i);
    });
}

const handler = {
    has: proxyHas,
    get: proxyGetOffset,
    getContingent: proxyGetOffsetContingent,
    getMonthly: proxyGetOffsetMonthly,
    keys,
    keysMonthly,
    momentFor,
    iterator,
    iteratorMonthly,
};

export default handler;
export { offsets as dateStrToOffset };
